import { render } from "./AutoLoad.vue?vue&type=template&id=361ab514&scoped=true"
import script from "./AutoLoad.vue?vue&type=script&lang=js"
export * from "./AutoLoad.vue?vue&type=script&lang=js"

import "./AutoLoad.vue?vue&type=style&index=0&id=361ab514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361ab514"]])

export default __exports__